module.exports = __webpack_public_path__ + "static/media/PricingDQWorkspace6.353fa533.png";